<template>
  <div class="container">
    <h1 class="title">Statistik</h1>
    <h2 class="subtitle">Für Ihren Store verfügbare Statistiken</h2>
    <div v-if="stats.length == 0">
      <div class="notification is-info">
        Derzeit sind keine Statistik Abfragen hinterlegt.
      </div>
    </div>
    <div v-if="stats.length > 0" class="columns">
      <div v-for="s in stats" :key="s.queryID" class="column is-6">
        <router-link
          :to="{name: 'statistik_query', params: {id: s.queryID.toLowerCase()}}"
          class="box"
        >
          <h3 class="is-size-4 has-text-weight-bold">{{ s.title }}</h3>
          <span>{{ s.description }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'StatisticOverview',
  computed: {
    ...mapGetters(['stats']),
  },
  mounted() {
    this.refreshStatistics()
  },
  methods: {
    ...mapActions(['refreshStatistics']),
  },
}
</script>
